import React from 'react'
import * as R from 'ramda'
import { jt, t } from 'ttag'

import { SelectResourceModal } from 'components/modals/common/SelectResourceModal/SelectResourceModal'
import { Detail } from 'components/shared/Detail/Detail'

import { useSelectCandidateGroupModalState } from './hooks'

import styles from './SelectCandidateGroupModal.module.scss'

export const SelectCandidateGroupModal = ({
  onCancel,
  onClose,
  onConfirm,
  isOpen,
}) => {
  const {
    state: { candidates, count, pks },
  } = useSelectCandidateGroupModalState()

  const message = R.gt(R.length(pks), 0) ? (
    <Detail className={styles.detail} key="candidates">
      <Detail.Content
        chipsClassName={styles.content}
        chips={R.map(({ name }) => name, candidates)}
        type="chipsGroup"
      />
    </Detail>
  ) : null

  return (
    <SelectResourceModal
      alert={jt`You are moving ${count} candidates listed below: ${message}`}
      className={styles.modal}
      message={t`Are you sure you want to move?`}
      title={t`Select candidates for interview`}
      {...{ onCancel, onClose, onConfirm, isOpen }}
    />
  )
}
